export default __webpack_public_path__ + "static/media/pause_white_48dp.55c91106.svg";